
/**
    * @param {字符串} str 
    * 判断字符串中是否含有连续4位以上连续递增 / 递减的数字
    */
export function upDownSpecial(str) {
    const incrementReg = /((?:0(?=1)|1(?=2)|2(?=3)|3(?=4)|4(?=5)|5(?=6)|6(?=7)|7(?=8)|8(?=9)|9(?=0)){3}\d)/
    const decrementReg = /((?:0(?=9)|9(?=8)|8(?=7)|7(?=6)|6(?=5)|5(?=4)|4(?=3)|3(?=2)|2(?=1)|1(?=0)){3}\d)/
    const isIncrement = incrementReg.test(str)
    const isDecrement = decrementReg.test(str)
    return isIncrement || isDecrement
}


// WEBPACK FOOTER //
// ./src/utils/index.js